import { NftsApi, CollectionsApi, UserApi } from 'clientSDK';

const api = new NftsApi();
const collectionsApi = new CollectionsApi();
const userApi = new UserApi();

export default {
  getNfts: async ({ buyNow = 0, owner, skip = 0, limit = 50 }) =>
    await api.list({ skip, limit, buyNow, owner }),

  getNftTokenFromId: async ({ contractAddress, tokenId }) =>
    await api.getNftTokenFromId({ contractAddress, tokenId }),

  getNftsFromAddress: async ({
    address,
    buyNow = 0,
    skip = 0,
    limit = 50,
    tokenIds = null,
    traits = {},
    min,
    max,
  }) =>
    await api.getNftsFromAddress({
      skip,
      limit,
      address,
      buyNow,
      tokenIds,
      traits: Object.keys(traits).length > 0 ? traits : undefined,
      min,
      max,
    }),

  getCollectionFromAddress: async ({ contractAddress }) =>
    await collectionsApi.getCollectionFromAddress({ address: contractAddress }),

  getAssetTradingHistory: async ({
    contractAddress,
    tokenId,
    listing = true,
    mint = true,
    sale = true,
    offer = true,
    bid = true,
    burn = true,
    transfer = true,
    skip = 0,
    limit = 50,
  }) =>
    await api.getTradingHistory({
      contractAddress,
      tokenId,
      listing,
      mint,
      sale,
      offer,
      bid,
      burn,
      transfer,
      skip,
      limit,
    }),

  getAssetOffers: async ({ contractAddress, tokenId, skip = 0, limit = 50, direction = 'desc' }) =>
    await api.getAssetOffers({ contractAddress, tokenId, skip, limit, direction }),

  getNftBids: async ({ contractAddresses, ownerAddress, limit, exclude }) =>
    await api.getNftBids({ contractAddresses, ownerAddress, limit, exclude }),

  getCollectionTradingHistory: async ({
    contractAddress,
    listing = true,
    mint = true,
    sale = true,
    offer = true,
    bid = true,
    burn = true,
    transfer = true,
    skip = 0,
    limit = 100,
    date,
  }) =>
    await api.getCollectionTradingHistory({
      contractAddress,
      listing,
      mint,
      sale,
      offer,
      bid,
      burn,
      transfer,
      skip,
      limit,
      date,
    }),

  updateCollectionImage: async ({ data }) => await userApi.updateCollectionImage({ data }),

  refreshMetadata: async ({ contractAddress, tokenId }) =>
    await api.refreshMetadata({ contractAddress, tokenId }),

  getPortfolioCollections: async (ownerAddress) => await collectionsApi.getPortfolio(ownerAddress),

  getPortfolioStats: async ({ collection, userAddress }) =>
    await userApi.getPortfolioStats({ collection, userAddress }),

  getNftsByOwnerInCollection: async ({ owner, collection, skip = 0, limit = 50 }) =>
    await api.getNftsByOwnerInCollection({ owner, contractAddress: collection, skip, limit }),

  getCollectionBidsFromAddress: async ({ address }) =>
    await collectionsApi.getCollectionBidsFromAddress({ address }),

  getLaunchpadCollection: async (collectionUrl) =>
    await collectionsApi.getLaunchpadCollection(collectionUrl),

  getCollectionChart: async (address) => await collectionsApi.getCollectionChart(address),

  cancelCollectionBid: async (orderKey) => await collectionsApi.cancelCollectionBid(orderKey),

  getOwnedBids: async (address) => await userApi.getOwnedBids(address),

  getTotalPlacedBids: async (address) => await userApi.getTotalPlacedBids(address),

  getCollectionHolders: async (address) => await collectionsApi.getCollectionHolders(address),
};
